import { perPlayerPrice } from "../../../constants/courtDomain";

/**
 * "Cada uno paga: $X" — the court price split across the attending players.
 *
 * Always derived at render time from `totalPrice / players`; the split is never
 * stored. A frozen share would drift the moment either input changes and would
 * be one more number to keep in sync for no gain.
 *
 * Renders nothing when the split cannot be computed (no price loaded yet, or a
 * court with no rate). Showing "$0 cada uno" there would read as "it's free",
 * which is a wrong answer wearing the clothes of a real one.
 *
 * `variant` picks the row shape of the surface it sits on: "summary" for the
 * desktop sidebar's `.rs-row`, "detail" for the desktop form's `.rdb-row`, and
 * "mobile" for the mobile checkout, whose rows are inline-styled rather than
 * class-based. The first two class families already exist in reservas.css —
 * this component only chooses between them, it does not restyle them.
 */
export default function PerPlayerPrice({
  totalPrice,
  players,
  variant = "summary",
  label = "Cada uno paga",
}) {
  const share = perPlayerPrice(totalPrice, players);
  if (share === null) return null;

  const amount = `$${share.toLocaleString("es-AR")}`;
  const detail = `${players} ${Number(players) === 1 ? "jugador" : "jugadores"}`;

  if (variant === "detail") {
    return (
      <div className="rdb-row">
        <span>
          {label} ({detail})
        </span>
        <strong>{amount}</strong>
      </div>
    );
  }

  if (variant === "mobile") {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ color: "var(--text)", opacity: 0.65, fontWeight: 600, fontSize: "13.5px" }}>
          {label} ({detail})
        </span>
        <strong style={{ color: "var(--text)", fontSize: "14px", fontWeight: 700 }}>
          {amount}
        </strong>
      </div>
    );
  }

  return (
    <div className="rs-row" style={{ fontSize: "13.5px", color: "var(--text)" }}>
      <span className="k">
        {label} ({detail})
      </span>
      <span className="v" style={{ fontWeight: 700 }}>
        {amount}
      </span>
    </div>
  );
}
